import { jsx as L, jsxs as l } from "react/jsx-runtime";
import "react";
var i = (F) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...F,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1794 -900)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0.000244141H0V7.10153H20V0.000244141Z",
      fill: "#338AF3"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 12.8987H0V20H20V12.8987Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.77395 4.50475C6.77395 3.73846 7.3125 3.09827 8.03168 2.9412C7.92117 2.91706 7.80645 2.90393 7.68867 2.90393C6.80453 2.90397 6.08789 3.62061 6.08789 4.50475C6.08789 5.38889 6.80453 6.10553 7.68867 6.10553C7.80648 6.10553 7.92113 6.09245 8.03168 6.06827C7.3125 5.91124 6.77395 5.27108 6.77395 4.50475Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M8.97664 5.23242L9.08504 5.5659H9.4357L9.15199 5.77207L9.26039 6.10555L8.97664 5.89949L8.69293 6.10555L8.80133 5.77207L8.51758 5.5659H8.86828L8.97664 5.23242Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M10.0957 5.23242L10.2041 5.5659H10.5548L10.2711 5.77207L10.3795 6.10555L10.0957 5.89949L9.81199 6.10555L9.92039 5.77207L9.63672 5.5659H9.98734L10.0957 5.23242Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.2149 5.23242L11.3233 5.5659H11.6739L11.3902 5.77207L11.4986 6.10555L11.2149 5.89949L10.9312 6.10555L11.0395 5.77207L10.7559 5.5659H11.1065L11.2149 5.23242Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M12.334 5.23242L12.4424 5.5659H12.7931L12.5094 5.77207L12.6178 6.10555L12.334 5.89949L12.0504 6.10555L12.1587 5.77207L11.875 5.5659H12.2257L12.334 5.23242Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.4532 5.23242L13.5615 5.5659H13.9122L13.6285 5.77207L13.7369 6.10555L13.4532 5.89949L13.1695 6.10555L13.2778 5.77207L12.9941 5.5659H13.3448L13.4532 5.23242Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M10.0957 4.06824L10.2041 4.40171H10.5548L10.2711 4.60785L10.3795 4.94136L10.0957 4.73527L9.81199 4.94136L9.92039 4.60785L9.63672 4.40171H9.98734L10.0957 4.06824Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.2149 4.06824L11.3233 4.40171H11.6739L11.3902 4.60785L11.4986 4.94136L11.2149 4.73527L10.9312 4.94136L11.0395 4.60785L10.7559 4.40171H11.1065L11.2149 4.06824Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M12.334 4.06824L12.4424 4.40171H12.7931L12.5094 4.60785L12.6178 4.94136L12.334 4.73527L12.0504 4.94136L12.1587 4.60785L11.875 4.40171H12.2257L12.334 4.06824Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.4532 4.06824L13.5615 4.40171H13.9122L13.6285 4.60785L13.7369 4.94136L13.4532 4.73527L13.1695 4.94136L13.2778 4.60785L12.9941 4.40171H13.3448L13.4532 4.06824Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.2149 2.90393L11.3233 3.23749H11.6739L11.3902 3.44354L11.4986 3.77713L11.2149 3.57096L10.9312 3.77713L11.0395 3.44354L10.7559 3.23749H11.1065L11.2149 2.90393Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M12.334 2.90393L12.4424 3.23749H12.7931L12.5094 3.44354L12.6178 3.77713L12.334 3.57096L12.0504 3.77713L12.1587 3.44354L11.875 3.23749H12.2257L12.334 2.90393Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.4532 2.90393L13.5615 3.23749H13.9122L13.6285 3.44354L13.7369 3.77713L13.4532 3.57096L13.1695 3.77713L13.2778 3.44354L12.9941 3.23749H13.3448L13.4532 2.90393Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 7.82605H0V12.1739H20V7.82605Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  i as default
};
